import {configureStore} from "@reduxjs/toolkit";
import filterReducer from "../src/features/filtering/filterSlice"
import appStatesReducer from "../src/features/app-states/statesSlice"
export const store = configureStore({
    reducer:{
        filtering: filterReducer,
        states: appStatesReducer,
    }
})